/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetListRequest {
    getFixupPrototypeFunction() { return BudgetListRequest.fixupPrototype; }

    static newInstance(model: Partial<BudgetListRequest>): BudgetListRequest {
        let obj = Object.assign(new BudgetListRequest(), model);
        BudgetListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetListRequest>): BudgetListRequest {
        if (!model) return null;
        return BudgetListRequest.newInstance(<BudgetListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetListRequest) {
        if (!obj) return;

        models.BudgetListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetListRequest): boolean {
        Object.setPrototypeOf(obj, BudgetListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.filters) {
            models.BudgetFilterModel.fixupPrototype(this.filters);
        }
    }

    /**
     * filter budgets based on filter data
     */
    filters: models.BudgetFilterModel;

    /**
     * Budget status. Allowed values are pending/in_progress/completed/expired
     */
    status: Array<models.BudgetStatus>;

    /**
     * Cost metric used to calculate the budget amount
     */
    billing_source: string;

    /**
     * budget engine can be Cloud_Native or System
     */
    budget_engine: models.BudgetEngine;

    /**
     * The name of the cloud service. For example, AWS.
     */
    service_name: Array<models.CloudServiceName>;

    /**
     * Specify the cloud account id to view, cloud account id is unique and can be obtained from the list cloud account api.
     */
    cloud_account_id: Array<string>;

    /**
     * Tenant ids
     */
    project_id: Array<string>;

    /**
     * Dimension IDs for the budget. This is a unique ID and can be retrieved using
     */
    dimension_id: Array<string>;

    /**
     * List of grouping rule IDs to be associated with the budget. This is a unique.
     */
    grouping_rule_ids: Array<string>;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

    /**
     * When true, returns only active budgets.
     */
    active_only: boolean = false;

    /**
     * ISO 8601 UTC datetime. When provided with end_date, filters to budgets whose period overlaps the given range.
     */
    start_date: Date;

    /**
     * ISO 8601 UTC datetime. When provided with start_date, filters to budgets whose period overlaps the given range.
     */
    end_date: Date;

}
